import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from '@material-ui/core'
import { LocalizedButton } from 'components/Localization/LocalizedButton'
import { PartTypeRow } from 'model/Project/BoMItemRow'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { RootAppState } from 'store/configureStore'
import { UIActions } from 'store/UI/UIActions'
import { MaterialSelectorUI } from '../../../model/MaterialSelectorUI'
import {
  KeywordDto,
  MaterialSummaryDto,
} from '../../../services/APIs/InternalAPI/internal-api.contracts'
import { MaterialActions } from '../../../store/MaterialSelector/MaterialStore'
import { SettingsActions } from '../../../store/Settings/SettingsStore'
import { LoadingContainer } from '../LoadingContainer'
import './ArticleSelectorDialog.scss'
import { AvailableArticles } from './AvailableArticles'
import { MaterialSelectorModalHeader } from './MaterialSelectorModalHeader'
import { TokenSelector } from './TokenSelector'

type OwnProps = {
  showSaveButton: boolean
  modalId: string
  isPurchasingPrice: boolean
  open: boolean
}

type StateProps = {
  materialSelectorUI: MaterialSelectorUI
  activeRows: PartTypeRow[]
  isLoading: boolean
  projectId: string
  organizationId: string
  openedMaterialSelectorId: string
}

type DispatchProps = {
  onChangeTokens: (selectedTokens: KeywordDto[]) => void
  onMaterialSelected: (selectedMaterial: MaterialSummaryDto) => void
  onClose: () => void
  saveRows: () => void
  flip3dModel: (rowId: string, reset: boolean) => void
  rotate3dModel: (rowId: string) => void
  addPurchasingData: (material) => void
}

export type ArticleSelectorDialogProps = StateProps & DispatchProps & OwnProps

const mapStateToProps = (state: RootAppState): StateProps => ({
  materialSelectorUI: state.materials.materialSelectorUI,
  activeRows: state.materials.activeRows,
  isLoading: state.materials.isLoading,
  projectId: state.project?.activeProject?.id,
  openedMaterialSelectorId: state.materials.currentElementId,
  organizationId: state.user.organizationContext.id,
})

const mapDispatchToProps = (dispatch): DispatchProps => ({
  onClose: () => {
    dispatch(MaterialActions.closeModal())
    dispatch(UIActions.CloseModal())
  },
  onChangeTokens: (selectedTokens: KeywordDto[]) =>
    dispatch(MaterialActions.changeTokens(selectedTokens)),
  onMaterialSelected: (material: MaterialSummaryDto) =>
    dispatch(MaterialActions.selectMaterial(material)),
  saveRows: () => {
    {
      // dispatch(projectActions.RemoveAllCalculatedFields())
      dispatch(MaterialActions.saveSelectedTokensAndMaterials())
    }
  },
  flip3dModel: (rowId: string, reset: boolean) =>
    dispatch(MaterialActions.flipModel(rowId, reset)),
  rotate3dModel: (rowId: string) =>
    dispatch(MaterialActions.rotateModel(rowId)),
  addPurchasingData: (material) =>
    dispatch(SettingsActions.addPurchasingData(material)),
})

const ArticleSelectorModal = (props: ArticleSelectorDialogProps) => {
  const { t } = useTranslation('project')

  // if (props.openedMaterialSelectorId !== props.modalId) return null
  const [saving, setSaving] = useState(false)

  const handleMaterialSelected = (
    material: MaterialSummaryDto,
    shouldSave = false
  ) => {
    props.onMaterialSelected(material)

    if (props.isPurchasingPrice) {
      props.addPurchasingData(material)
    }

    if (shouldSave && props.saveRows) {
      props.saveRows()
    }
  }

  return (
    <Dialog
      open={true}
      onClose={props.onClose}
      disableRestoreFocus
      fullWidth
      maxWidth="xl"
    >
      {/* <LoadingContainer loading={props.openedMaterialSelectorId !== props.modalId}> */}
      <DialogTitle>
        <MaterialSelectorModalHeader
          {...props.activeRows[0]}
          title={t('project:article-selector--title', 'article selector')}
        />
      </DialogTitle>
      <DialogContent className="material-selector--content">
        <LoadingContainer
          loading={
            props.isLoading || props.openedMaterialSelectorId !== props.modalId
          }
          variant="spinner"
          noMessage
        >
          <Grid container spacing={1} style={{ height: '100%' }}>
            <Grid item xs={4}>
              <TokenSelector
                {...props.materialSelectorUI}
                width={'100%'}
                onTokensChanges={(tokens) => props.onChangeTokens(tokens)}
              />
            </Grid>
            <Grid item xs>
              <AvailableArticles
                {...props.materialSelectorUI}
                width={'100%'}
                onMaterialSelected={handleMaterialSelected}
              />
            </Grid>
            {/* {props.activeRows.length === 1 &&
              props.activeRows[0].id !== '000-000-000' && (
                <Grid item md className="material-selector--model">
                  <MaterialPosition
                    filePaths={{
                      threeDFilePath: props.activeRows[0].threeDModelPath,
                      twoDFilePath: props.activeRows[0].twoDModelPath,
                    }}
                    rowId={props.activeRows[0].id}
                    projectId={props.projectId}
                    shallHaveSelectedDirection={
                      props.activeRows[0].materialSummary
                        .shallHaveSelectedDirection
                    }
                    shallSelectSide={
                      props.activeRows[0].materialSummary.shallSelectSide
                    }
                    flip={props.flip3dModel}
                    rotate={props.rotate3dModel}
                    width={'100%'}
                    organizationId={props.organizationId}
                  />
                </Grid>
              )} */}
          </Grid>
        </LoadingContainer>
      </DialogContent>
      <DialogActions>
        <LocalizedButton
          translationKey={'common:close'}
          color="secondary"
          onClick={props.onClose}
        />
        {props.showSaveButton && (
          <LocalizedButton
            translationKey="common:save"
            color="primary"
            variant="contained"
            onClick={() => {
              setSaving(true)
              props.saveRows()
            }}
            disabled={saving}
          />
        )}
      </DialogActions>
      {/* </LoadingContainer> */}
    </Dialog>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArticleSelectorModal)
